<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Company Detail Info
    </div>
    <div class="enterprise-network_container">
      <el-form ref="form" label-position="top" :model="formData" :rules="rules">
        <div class="enterprise-network_grid grid-1x2 gap_80">
          <el-form-item prop="companyName">
            <template #label>
              <div class="enterprise-network-label_required">
                Company Full Name
              </div>
            </template>
            <el-select
              ref="companyNameSelectRef"
              v-model="formData.companyName"
              placeholder=""
              allow-create
              clearable
              filterable
              remote
              style="width: 100%"
              default-first-option
              @input.native="handleCompanyNameInput"
              :disabled="!isSeniorEditor"
            >
              <el-option
                v-for="(item, index) in companyList"
                :key="index"
                :label="item.customerName"
                :value="item.customerName"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="address">
            <template #label>
              <div class="enterprise-network-label_required">
                Business License Address
              </div>
            </template>
            <el-input
              v-model="formData.address"
              @blur="event => (formData.address = event.target.value.trim())"
              :disabled="!isSeniorEditor && partnerType !== 'RCP'"
            />
          </el-form-item>
        </div>
        <div class="enterprise-network_grid grid-1x2 gap_80">
          <el-form-item prop="companyFullName">
            <template #label>
              <div class="enterprise-network-label">
                Company Full Name (Local Language)
              </div>
            </template>
            <el-input
              v-model="formData.companyFullName"
              @blur="
                event => (formData.companyFullName = event.target.value.trim())
              "
              :disabled="!isSeniorEditor"
            />
          </el-form-item>
          <el-form-item prop="companyWebsite">
            <template #label>
              <div class="enterprise-network-label">
                Company Website
              </div>
            </template>
            <el-input
              v-model="formData.companyWebsite"
              @blur="
                event => (formData.companyWebsite = event.target.value.trim())
              "
            />
          </el-form-item>
        </div>
        <div class="enterprise-network_grid grid-1x2 gap_80">
          <el-form-item prop="legalRepresentative">
            <template #label>
              <div class="enterprise-network-label">
                Legal Representative
              </div>
            </template>
            <el-input
              v-model="formData.legalRepresentative"
              @blur="
                event =>
                  (formData.legalRepresentative = event.target.value.trim())
              "
            />
          </el-form-item>
          <el-form-item prop="organizationCode">
            <template #label>
              <div class="enterprise-network-label">
                Organization Code
                <el-tooltip placement="top" effect="light">
                  <img
                    src="@/assets/tool-tip_icon.svg"
                    width="18px"
                    height="18px"
                    alt=""
                  />
                  <template #content>
                    <div class="text-content">
                      Note: This is a number assigned by local govermment
                      agencise to identify a business within the local market.
                      Examples of include the VAT Number in Europe, the Siret
                      Number in France, the Company Number in Australia, and the
                      State Registry Number in Brazil.
                    </div>
                  </template>
                </el-tooltip>
              </div>
            </template>
            <el-input
              v-model="formData.organizationCode"
              @blur="
                event => (formData.organizationCode = event.target.value.trim())
              "
            />
          </el-form-item>
        </div>
        <div class="enterprise-network_grid grid-1x2 gap_80">
          <el-form-item prop="peopleNumber">
            <template #label>
              <div class="enterprise-network-label">
                Number of Employees
              </div>
            </template>
            <el-input
              v-model="formData.peopleNumber"
              maxlength="4"
              @change="handleEmployeesChange"
            />
          </el-form-item>
          <el-form-item prop="setUpDate">
            <template #label>
              <div class="enterprise-network-label">
                Date of Foundation
              </div>
            </template>
            <el-date-picker
              v-model="formData.setUpDate"
              style="width: 100%;"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { searchCustomer } from "../../../../../../api/international";

export default {
  name: "enterpriseNetworkCompanyDetailInfoEdit",
  props: {
    isSeniorEditor: {
      type: Boolean,
      default: false
    },
    partnerType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        companyName: "",
        address: "",
        companyFullName: "",
        companyWebsite: "",
        legalRepresentative: "",
        organizationCode: "",
        peopleNumber: "",
        setUpDate: ""
      },
      rules: {
        companyName: [
          {
            required: true,
            message: "Please select company name",
            trigger: "change"
          }
        ],
        address: [
          {
            required: true,
            message: "Please input business license address",
            trigger: "blur"
          }
        ]
      },
      companyList: []
    };
  },
  methods: {
    // 失去焦点的时候
    handleEmployeesChange(value) {
      this.formData.peopleNumber = value
        .replace(/[^1-9\d]/g, "")
        .replace(/^0+/g, "");
    },
    setFormData(formData) {
      if (!formData) return;
      this.formData = JSON.parse(JSON.stringify(formData));
    },
    getFormData() {
      let isPass = false;
      this.$refs.form.validate(valid => {
        isPass = valid;
      });

      if (!isPass) return false;
      return JSON.parse(JSON.stringify(this.formData));
    },
    // 搜索公司
    searchCompany(searchValue) {
      if (!searchValue) {
        this.companyList = [];
        this.formData.companyName = "";
        return;
      }
      searchCustomer(searchValue.trim())
        .then(response => {
          let { status, data } = response;
          if (Number(status) === 200) {
            if (data && data.length < 1) {
              this.companyList = [];
            } else {
              this.companyList = data || [];
            }
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    handleCompanyNameInput(event) {
      this.formData.companyName = event.target.value.trim();
      this.searchCompany(this.formData.companyName);
    }
  }
};
</script>
<style scoped>
.text-content {
  width: 360px;
}
</style>
<style>
.el-tooltip__popper {
  border: none !important;
  font-size: 16px;
  color: #505050;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08) !important;
}

.popper__arrow {
  border: none !important;
  z-index: 3000;
  transform: translateY(-1px);
}
</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/EBG/components/companyDetailInfo/companyDetailInfoEdit.vue